import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { actionLogoutUser } from '../../store/Account/actions';
import { StyledButton } from '../Shared/styled-button';
import Documents from './documents';

const App = () => {
    const dispatch = useDispatch();

    return (
        <Page>
            <Logo src="/assets/soar_logo_large.png" alt="Soar Logo" />

            <TextContainer>
                <Text>
                    Thank you for your interest in Soar.Earth Ltd. These documents are ONLY for NON-CITIZENS of the
                    United States of America. The documents therein are strictly confidential and can not be
                    re-distributed without prior consent of the Soar management team, Board and/or corporate advisors.
                </Text>

                <Text>
                    Soar.Earth Ltd reserves the right to change these documents partly, or wholly without notice.
                </Text>
            </TextContainer>

            <Documents />

            <LogoutButton
                onClick={() => {
                    dispatch(actionLogoutUser());
                }}
            >
                Logout
            </LogoutButton>
        </Page>
    );
};

export default App;

const Page = styled.div`
    min-width: 100vw;
    min-height: 100vh;
    background: ${(props) => props.theme.color.background};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Logo = styled.img`
    width: 350px;
    height: 155px;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    max-width: 600px;
    padding: 32px;
    border: 1px solid rgb(255 255 255 / 0.3);
    background-color: transparent;
    border-radius: 6px;
`;

const Text = styled.p`
    color: white;
    font-size: 1.2rem;
`;

const LogoutButton = styled(StyledButton)`
    position: fixed;
    top: 20px;
    right: 20px;
`;
